module.exports = __webpack_public_path__ + "static/media/author-spot1.93fae92b.png";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/author-spot1.png
// module id = 1788
// module chunks = 1